module.exports = __webpack_public_path__ + "static/media/game-controller@3x.19466c4e.png";